import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { useError } from './composable/useError'
import { CONFIG } from './config'

const { applicationErrorHandler } = useError()

const app = createApp(App)

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    app,
    dsn: CONFIG.SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  })
}

// app.config.errorHandler = applicationErrorHandler

app.use(Quasar, quasarUserOptions)
app.use(router)
app.mount('#app')
